module.exports = __webpack_public_path__ + "static/media/hp-home-banner-@2x.08b97948.jpg";